import { Phone } from "lucide-react";

export default function FloatingPhone({ tel, testId = "floating-phone" }) {
    if (!tel) return null;
    return (
        <a
            href={`tel:${tel}`}
            data-testid={testId}
            aria-label="Llamar por teléfono"
            className="hidden md:inline-flex fixed bottom-6 left-6 z-30 w-12 h-12 items-center justify-center rounded-full bg-eclipse-primary text-white shadow-xl hover:bg-eclipse-cta transition-colors"
        >
            <Phone className="w-5 h-5" strokeWidth={2} />
        </a>
    );
}
